module.exports = __webpack_public_path__ + "static/media/radio_checked.d203b4ce.svg";